import React from "react";
import { ENQUIRY_FORM_TYPE_BADGES } from "./enquiry-settings";
import { formatEnquiryDate, normalizeExternalUrl } from "./enquiry-helpers";

export const EnquiryDateCell = ({ value }: { value?: string | number | null }) => (
    <span className="whitespace-nowrap text-sm">{formatEnquiryDate(value)}</span>
);

export const EnquiryFormTypeBadge = ({ value }: { value: string }) => {
    if (!value || value === "-") return <span>-</span>;
    const tone = ENQUIRY_FORM_TYPE_BADGES[value] ?? "bg-gray-100 text-gray-700";
    return (
        <span className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium ${tone}`}>
            {value}
        </span>
    );
};

export const EnquiryTruncatedText = ({ value }: { value?: string }) => {
    if (!value || value === "-") return <span>-</span>;
    return (
        <span className="block max-w-xs truncate text-sm" title={value}>
            {value}
        </span>
    );
};

export const EnquiryLinkCell = ({ href, label }: { href?: string; label?: string }) => {
    if (!href) return <span>-</span>;
    const link = normalizeExternalUrl(href);
    return (
        <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline break-all text-sm"
            onClick={(event) => event.stopPropagation()}
        >
            {label || href}
        </a>
    );
};
